import { useMemo } from 'react';

import { showAlert } from 'components/shared/Alert/Alert';

import { IMPORT_TYPE } from './lib';

export const useImportActions = ({ props, modals, form }) => {
  const defaultActions = useMemo(
    () => [
      {
        text: 'View past imports',
        onClick: () => modals.setShowPastImports(true),
        color: 'neutral',
        style: 'outlined'
      },
      {
        text: 'Import',
        iconRight: 'chevron-right-linear',
        iconColor: 'white',
        onClick: () => {
          if (
            form.initialImportForm.numberOfPatients === '0' ||
            form.initialImportForm.numberOfPatients === ''
          ) {
            return showAlert({ title: 'Please provide a number of patients', color: 'danger' });
          } else if (!form.initialImportForm.selectedType) {
            return showAlert({ title: 'Please select an import type', color: 'danger' });
          }
          handleInitialFormSubmit(form.initialImportForm.selectedType);
        }
      }
    ],
    [form.initialImportForm.selectedType, form.initialImportForm.numberOfPatients]
  );

  const handleInitialFormSubmit = (selectedType) => {
    if (selectedType === IMPORT_TYPE.CSV_IMPORT) {
      modals.setShowImportCSV(true);
    } else if (selectedType === IMPORT_TYPE.SOFTWARE_EXPORT) {
      modals.setShowSoftwareExport(true);
      props.updateConfigs({
        goBackHandler: props.onPrev,
        actions: [
          {
            text: 'Skip for now',
            onClick: props.onNext,
            style: 'outlined'
          },
          {
            text: 'Continue',
            iconRight: 'chevron-right-linear',
            iconColor: 'white',
            onClick: () => {
              modals.setShowSoftwareExport(false);
              modals.setShowProcessingFiles(true);
              props.updateConfigs({
                goBackHandler: props.onPrev,
                message:
                  'Your data will be processed while you can continue with the rest of the setup.',
                actions: [
                  {
                    text: 'Import More',
                    onClick: () => {
                      modals.setShowProcessingFiles(false);
                      props.updateConfigs({
                        goBackHandler: props.onPrev,
                        actions: defaultActions
                      });
                    },
                    outlined: true
                  },
                  {
                    text: 'Continue',
                    onClick: props.onNext,
                    iconRight: 'chevron-right-linear',
                    iconColor: 'white'
                  }
                ]
              });
            }
          }
        ]
      });
    }
  };

  return {
    defaultActions,
    handleInitialFormSubmit
  };
};
